module.exports = __webpack_public_path__ + "img/1479702928.4564cace.jpg";